import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, P, Stack, Text, useText } from "@sveabank/cc-common";
import Paper from "../../../../components/paper";
import type { ClcRepresentative } from "../../../../types/clc-application";

type Props = {
	open: boolean;
	setOpen: (isOpen: boolean) => void;
	person: ClcRepresentative;
	deleteRepresentative: (nationalId: string) => void;
};

export const DeleteRepresentativeModal = ({
	open,
	setOpen,
	person,
	deleteRepresentative,
}: Props) => {
	const [t, texts] = useText();

	return (
		<Dialog
			isOpen={open}
			setOpen={setOpen}
			icon="error"
			center
			size="small"
			heading={t(texts.newCompany.companyStructure.deleteRepresentativeModalHeading)}
		>
			<Dialog.Content>
				<Stack gap={4}>
					<Stack gap={2}>
						<Text align="start">
							{t(texts.newCompany.companyStructure.deleteRepresentativeModalText)}
						</Text>
					</Stack>

					<Paper className="bg-background-tertiary">
						<Text align="left">
							<Text component="p" bold>
								{person.firstName} {person.lastName}
							</Text>
							<P>{person.postalAddress}</P>
							<P>
								{person.postCode} {person.town}
							</P>
						</Text>
					</Paper>
				</Stack>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button
						onPress={() => {
							deleteRepresentative(person.nationalId);
							setOpen(false);
						}}
					>
						{t(texts.common.remove)}
					</Button>
					<Button variant="secondary" onPress={() => setOpen(false)}>
						{t(texts.common.abort)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};
